export enum InputType {
  TEXT_FIELD,
  DATE_PICKER,
  EMAIL
}
